import type { InvoiceData } from "@/apis/gql/types";
import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

type InvoiceNoRow = {
  invoice: Pick<InvoiceData, "invoiceNo">;
};

const invoiceNoColumn = <T extends InvoiceNoRow>(): ColumnDef<T> => {
  return {
    accessorKey: "invoice.invoiceNo",
    id: "invoiceNo",
    header: ({ column }) => {
      const { t } = useTranslation();

      return (
        <DataTableColumnHeader column={column} title={t("invoice_number")} />
      );
    },
    cell: (cell) => {
      const invoiceNo = cell.row.original.invoice.invoiceNo;
      if (!invoiceNo) return null;

      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="truncate"># {invoiceNo}</div>
          </TooltipTrigger>
          <TooltipContent>
            <p># {invoiceNo}</p>
          </TooltipContent>
        </Tooltip>
      );
    },
  };
};

export default invoiceNoColumn;
